// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_MzP","cls2":"SearchOnboardingOverhaul-cls2__5Y SearchOnboardingOverhaul-cls1_MzP"};